import { TARGET_TYPE } from '../../utils/target-scope.utils';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';

export async function withSurfaceTarget<T>({
  targetType,
  runExternal,
  runInternal,
}: {
  targetType: TargetTypeType;
  runExternal: () => Promise<T>;
  runInternal: () => Promise<T>;
}): Promise<T> {
  if (targetType === TARGET_TYPE.INTERNAL_NETWORK) {
    return runInternal();
  }
  return runExternal();
}
